import { FC, type ReactNode } from 'react';
import type { ButtonProps as MUIButtonProps } from '@mui/material/Button';
import { IconButtonProps as MUIIconButtonProps } from '@mui/material/IconButton';
import { StyledButton, StyledButtonProps, StyledIconButton, type StyledIconButtonProps } from './styles';
import { type To } from 'react-router';

export type ButtonProps = MUIButtonProps & StyledButtonProps & { additionalChildren?: ReactNode, to?: To }

export const Button: FC<ButtonProps> = props => {
  const { variantStyle = 'regular', additionalChildren, children, ...rest } = props;
  return <StyledButton
    variantStyle={variantStyle}
    disableFocusRipple
    disableRipple = {variantStyle === 'text'}
    {...rest}
  >
    {children}
    {additionalChildren && <span className={'additionalText'}>{additionalChildren}</span>}
  </StyledButton>;
};

type IconButtonProps = MUIIconButtonProps & {
  active?: boolean;
}

export const IconButton = (props: IconButtonProps & StyledIconButtonProps) => {
  const { variantStyle = 'accent', size = 'medium', ...rest } = props;
  return <StyledIconButton variantStyle={variantStyle} size={size} {...rest} />;
};
